import { useState } from "react";
import ElementLabel from "../ElementLabel.jsx";

// Domande personalizzate del wizard di prenotazione (es. "Taglia casco").
// L'admin definisce qui le etichette; l'utente risponde a testo libero nello step
// dati partecipanti (prima delle Osservazioni). Scrive su inputData.bookingCustomFields.
// Da NON confondere con customOptions (sezioni informative della pagina di dettaglio).
const BookingCustomFieldsEditor = ({ inputData, setInputData }) => {
    const [fieldInput, setFieldInput] = useState('');

    const addField = () => {
        const label = fieldInput.trim();
        if (label === '') return;
        setInputData(prevState => ({
            ...prevState,
            bookingCustomFields: [...(prevState.bookingCustomFields || []), { label }]
        }));
        setFieldInput('');
    };

    const removeField = (label) => {
        setInputData(prevState => ({
            ...prevState,
            bookingCustomFields: prevState.bookingCustomFields.filter(element => element.label !== label)
        }));
    };

    return (
        <div className="flex flex-col gap-2 w-full">
            <div className="flex gap-2 w-full">
                <input type="text" className="flex-grow" placeholder='Es. "Taglia casco"' onChange={(event) => setFieldInput(event.target.value)} value={fieldInput} />
                {fieldInput.trim() !== '' && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1 shrink-0" onClick={addField}>+</button>}
                {fieldInput.trim() === '' && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed shrink-0">+</button>}
            </div>
            <div className="border-2 p-2 flex gap-2 flex-wrap min-h-[72px] rounded">
                {
                    inputData && inputData.bookingCustomFields && inputData.bookingCustomFields.length > 0 && inputData.bookingCustomFields.map((element, index) => {
                        return <ElementLabel key={index} string={element.label} close={removeField} />
                    })
                }
            </div>
        </div>
    )
}

export default BookingCustomFieldsEditor;
